<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('embroideries')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="50"
      resource_url="/embroidery/datatables"
      mode="grid"
      grid_class="is-col-min-10"
      ><template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <!-- <div
              class="is-pulled-right has-text-warning"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </div> -->
            <figure class="image is-64x64 m-auto" @click="edit(item)">
              <v-lazy-image
                v-if="item.image"
                :src="`${api_host}/drive/static/${item.image}`"
              />
              <img
                v-else
                src="https://cdn-icons-png.flaticon.com/512/2769/2769754.png"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="edit(item)">
            <div class="media">
              <div class="media-content">
                <div class="title is-5 has-text-centered">
                  {{ item.name }}
                </div>
                <div class="subtitle is-6 mb-1 has-text-centered">
                  {{ item.customer.name }}
                </div>
                <div class="subtitle is-6 has-text-centered">
                  <span class="tag is-primary is-medium">{{
                    format_currency(item.sale_price)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <footer class="card-footer" v-show="false">
            <a
              class="card-footer-item button"
              :data-tooltip="$t('edit')"
              @click="edit(item)"
            >
              <span class="icon"><i class="fa fa-edit"></i></span>
            </a>
            <a
              class="card-footer-item has-text-danger button"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </a>
            <a
              class="card-footer-item button"
              :data-tooltip="$t('file list')"
              @click="file_list(item)"
            >
              <span class="icon"><i class="fa fa-list"></i></span>
            </a>
          </footer>
        </div> </template
    ></generic-table>
  </div>

  <embroidery-modal
    ref="embroidery_modal"
    @success="refresh"
    :module_settings="module_settings"
  />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import EmbroideryModal from "./embroidery_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "EmbroideryDatatable",
  components: { GenericTable, EmbroideryModal, VLazyImage },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("data"),
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return row.barcode || "";
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.embroidery_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    edit(item) {
      let v = this;
      v.$refs.embroidery_modal.edit_modal(item.uuid);
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete embroidery?"),
        v,
        () => {
          del("/embroidery", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
